import { useCallback, useMemo } from "react";
import { useQuery } from "@apollo/client";
import {
  UPDATED_REASON_FOR_VISIT,
} from "../../services/updated-reason-for-visit/updated-reason-for-visit.query";
import {
  IUpdatedReasonForVisitResponse,
} from "../../services/updated-reason-for-visit/updated-reason-for-visit.interface";
import { IOptionGeneric } from "../../shared/interface";
import {
  useUrgentVisitStore,
} from "../redux-hooks/urgent-visit-store/urgent-visit.store";

const REASON_CATEGORY_SICK = "Sick";

export const useUrgentVisitReasons = () => {
  const {
    selectedPets, petBookingData, currentPetIndex, setPetReasons,
  } = useUrgentVisitStore();

  const currentPet = selectedPets[currentPetIndex];
  const currentPetData = currentPet ?
    petBookingData[currentPet.id] : undefined;
  const selectedReasons = useMemo(
    () => currentPetData?.selectedReasons ?? [],
    [currentPetData?.selectedReasons],
  );

  const { data, loading } = useQuery<{
    fetchReasonsForVisit: IUpdatedReasonForVisitResponse;
  }>(UPDATED_REASON_FOR_VISIT);

  const sickReasons: IOptionGeneric[] = (() => {
    if (!data?.fetchReasonsForVisit?.items) return [];
    const sickCategory = data.fetchReasonsForVisit.items.find(
      (item) => item.name === REASON_CATEGORY_SICK,
    );

    if (!sickCategory) return [];

    return sickCategory.options.map((option) => ({
      value: option,
      label: option,
    }));
  })();

  const toggleReason = useCallback(
    (reason: string) => {
      if (!currentPet) return;

      const updated = selectedReasons.includes(reason) ?
        selectedReasons.filter((r) => r !== reason) :
        [...selectedReasons, reason];

      setPetReasons(currentPet.id, updated);
    },
    [currentPet, selectedReasons, setPetReasons],
  );

  return {
    reasons: sickReasons,
    loading,
    selectedReasons,
    toggleReason,
  };
};
